import { Outlet, useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';
import { useQuery } from 'urql';
import { EditJobForm } from '~/components/job/EditJobForm';
import { Loading } from '~/components/ui/Loading';
import { graphql } from '~/gql';
import { JobDocument, JobStatus } from '~/gql/graphql';
import { isJobEditDataReady } from '~/helpers/isJobEditDataReady';

const { Created } = JobStatus;

const EditJobFormDocument = graphql(`
  query EditJobForm {
    integrations
    attributes(entityType: "Site") {
      id
      type
      category
      name
      value
      condition
    }
    jobTemplates(status: Active) {
      ...JobTemplateFields
    }
    contacts(status: Active) {
      ...ContactFields
    }
  }
`);

// TODO remove this
function useJobFormData(jobId: string) {
  const [formResult] = useQuery({
    query: EditJobFormDocument,
  });

  const [jobResult, reexecuteQuery] = useQuery({
    query: JobDocument,
    variables: { id: jobId },
    pause: jobId === undefined,
    requestPolicy: 'cache-and-network',
  });

  return {
    form: formResult.data,
    job: jobResult.data,
    reload: () => reexecuteQuery({ requestPolicy: 'network-only' }),
  };
}

export function Component() {
  const { jobId } = useParams();

  invariant(jobId, 'jobId is required');

  // Destructuring an restructuring the data is required for typescript to
  // understand the undefined guards below.
  const { form, job: data, reload } = useJobFormData(jobId);

  // Keep the form mounted during background refetches of the same job.
  // Waiting on fetching/stale remounts EditJobForm when contacts are created,
  // which resets the Who panel. Still wait until the loaded job matches the
  // route so a job-id change cannot reuse the previous job's form state.
  const job = data?.job;
  if (!job || !isJobEditDataReady(form, job, jobId)) {
    return <Loading spinner />;
  }

  return (
    <>
      <EditJobForm
        key={jobId}
        form={form}
        job={job}
        onSuccess={(status) => {
          if (status === Created) {
            reload();
          }
        }}
      />
      <Outlet />
    </>
  );
}
